export default "__VITE_ASSET__Dx_VJ_uu__"